<template>
  <div style="text-align: center;">
      <img alt="Easy Tailor App Logo" src="../../assets/eta.png" :style="'width: '+(days_left ? '100px' : '150px')+';'">
      <br><br><br>
      <h1 v-if="!days_left">
          Either your account is in dormant state due to long time inactivity or your account has expired.
      </h1>
      <span v-else style="font-size: 24px; font-weight: bold;">
        Your account expires in {{ days_left }} days.
      </span>
      <span>
          For further assistance, please contact us by clicking <a href="https://easytailorapp.com/contactus/">here</a>.
      </span>
  </div>
</template>

<script>
export default {
    props: ['days_left']
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/AccountExpired/Index.vue